module.exports = __webpack_public_path__ + "static/media/icon_jhfgdbh.c44ed6da.png";